import React, { FunctionComponent } from 'react'
import { SortDirection } from '../../../../../constants/direction'
import Button from '../../../../controls/Button/Button'
import { userActions } from '../../../../../redux/global/user/user-actions'
import { toggleBool } from '../../../../../utils/utils'
import { useRootDispatch, useRootSelector } from '../../../../../utils/hooks'
import SortIcon from 'files/sort.svg'
import clsx from 'clsx'
import { Classes } from '../../../../../styles'

const DirectionPicker: FunctionComponent = () => {
    const dispatch = useRootDispatch()
    const direction = useRootSelector(state => state.global.user.data?.settings.history_direction ?? SortDirection.DESC)
    return <Button
        title={direction === SortDirection.DESC ? 'Новые снизу' : 'Новые сверху'}
        onClick={() => dispatch(userActions.update.request({
            settings: {
                history_direction: toggleBool(direction),
            }
        }))}
    >
        <SortIcon className={clsx({ [Classes.flip]: direction === SortDirection.DESC })}/>
    </Button>
}

export default DirectionPicker